import React, { Component } from "react";
import axios from "axios";
import { Table, Alert, Tooltip, Space } from "antd";
import { SwapOutlined } from "@ant-design/icons";
import { ButtonItem } from "../../../../Components/Items";
import ModalMoverUbicacion from "./ModalMoverUbicacion";

//Desglose de existencia por ubicación de un insumo dentro de un almacén, con acción para mover cantidad
//a otra ubicación. Se usa tanto en el panel expandible de Inventario.js como en InventarioProducto.js.
class DesgloseUbicacionesInsumo extends Component {
  state = {
    loading: false,
    ubicaciones: [],
    sinUbicacionAsignada: null,
    puedeMoverUbicacion: true,
    catalogoUbicaciones: [],
    modalMoverVisible: false,
    ubicacionOrigen: null,
  };

  componentDidMount() {
    this.cargarDesglose();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.insumoId !== this.props.insumoId ||
      prevProps.proyectoId !== this.props.proyectoId ||
      prevProps.refreshKey !== this.props.refreshKey
    ) {
      this.cargarDesglose();
    }
  }

  async cargarDesglose() {
    if (!this.props.insumoId || !this.props.proyectoId) return;
    this.setState({ loading: true });
    try {
      const res = await axios.post(
        "ubicacionProyecto/selectExistenciaPorUbicacionInsumo",
        {
          empresaId: this.props.empresaId,
          proyectoId: this.props.proyectoId,
          insumoId: this.props.insumoId,
        },
        { headers: this.props.headersToken }
      );
      if (res.data.success === 2) {
        this.setState({
          ubicaciones: res.data.ubicaciones || [],
          sinUbicacionAsignada: res.data.sinUbicacionAsignada,
          puedeMoverUbicacion: res.data.puedeMoverUbicacion !== false,
          catalogoUbicaciones: res.data.catalogoUbicaciones || [],
        });
      }
    } catch (error) {
      console.error("Error al cargar el desglose por ubicación:", error);
    } finally {
      this.setState({ loading: false });
    }
  }

  abrirModalMover(ubicacionOrigen) {
    this.setState({ modalMoverVisible: true, ubicacionOrigen });
  }

  cerrarModalMover() {
    this.setState({ modalMoverVisible: false, ubicacionOrigen: null });
  }

  onMoverExitoso() {
    this.cerrarModalMover();
    this.cargarDesglose();
  }

  render() {
    const columns = [
      {
        title: "Ubicación",
        key: "ubicacion",
        render: (_, record) => (
          <span>
            <strong>{record.clave}</strong>
            {record.nombre ? ` - ${record.nombre}` : ""}
          </span>
        ),
      },
      {
        title: "Cantidad",
        dataIndex: "cantidad",
        key: "cantidad",
        align: "right",
        render: (value) => Number(value || 0).toFixed(4),
      },
      {
        title: "Cap. Máxima",
        dataIndex: "cantidadMaxima",
        key: "cantidadMaxima",
        align: "right",
        render: (value) => (value || value === 0 ? value : "-"),
      },
      {
        title: "",
        key: "acciones",
        width: 60,
        render: (_, record) => (
          <Tooltip
            title={
              this.state.puedeMoverUbicacion
                ? "Mover a otra ubicación"
                : "Este insumo maneja marbetes, lotes/caducidades o agrupaciones; no se puede mover desde aquí"
            }
          >
            <ButtonItem
              size="small"
              icon={<SwapOutlined />}
              disabled={!this.state.puedeMoverUbicacion}
              onClick={() => this.abrirModalMover(record)}
            />
          </Tooltip>
        ),
      },
    ];

    return (
      <div style={{ padding: "8px 24px", background: "#fafafa" }}>
        <Table
          size="small"
          rowKey={(record) => String(record.ubicacionId)}
          dataSource={this.state.ubicaciones}
          columns={columns}
          pagination={false}
          loading={this.state.loading}
          locale={{ emptyText: "Este insumo no tiene existencia en ninguna ubicación de este almacén" }}
        />
        {this.state.sinUbicacionAsignada?.cantidad > 0 && (
          <Alert
            style={{ marginTop: 8 }}
            type="warning"
            showIcon
            message={
              <Space>
                {`Hay ${Number(this.state.sinUbicacionAsignada.cantidad).toFixed(4)} unidades sin ubicación asignada en este almacén`}
                <Tooltip
                  title={
                    this.state.puedeMoverUbicacion
                      ? "Asignarles una ubicación"
                      : "Este insumo maneja marbetes, lotes/caducidades o agrupaciones; no se puede asignar desde aquí"
                  }
                >
                  <ButtonItem
                    size="small"
                    disabled={!this.state.puedeMoverUbicacion}
                    onClick={() =>
                      this.abrirModalMover({
                        ubicacionId: null,
                        clave: "Sin ubicación asignada",
                        nombre: "",
                        cantidad: this.state.sinUbicacionAsignada.cantidad,
                      })
                    }
                  >
                    Asignar ubicación
                  </ButtonItem>
                </Tooltip>
              </Space>
            }
          />
        )}
        <ModalMoverUbicacion
          visible={this.state.modalMoverVisible}
          onClose={() => this.cerrarModalMover()}
          onSuccess={() => this.onMoverExitoso()}
          empresaId={this.props.empresaId}
          headersToken={this.props.headersToken}
          proyectoId={this.props.proyectoId}
          insumoId={this.props.insumoId}
          insumoNombre={this.props.insumoNombre}
          ubicacionOrigen={this.state.ubicacionOrigen}
          catalogoUbicaciones={this.state.catalogoUbicaciones}
          ubicacionesConExistencia={this.state.ubicaciones}
        />
      </div>
    );
  }
}

export default DesgloseUbicacionesInsumo;
